<template>
  <div class="col-6 col-lg-3 mb-4 mb-lg-0">
    <div class="card mb-4">
      <a
        :href="`/lessons/${lesson.id}`"
        target="_blank"
        title="title"
        class="text-decoration-none"
      >
        <img
          :src="`${lesson.series.image}?w=350`"
          class="card-img-top"
          :alt="title"
          loading="lazy"
        >

        <div class="card-body">
          <h5 class="card-title mb-0">
            {{ title }}
          </h5>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "LessonItem",

  props: {
    lesson: {
      type: Object,
      required: true,
    },
  },

  computed: {
    title() {
      return (this.lesson.translatedTitle || this.lesson.title);
    },
  },
};
</script>
